module.exports = __webpack_public_path__ + "static/img/kuaichong.af51afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kuaichong.png
// module id = sKmQ
// module chunks = 1